/* ==========================================================================
   Bullantic — app-style mobile menu behaviour
   Panel stack (push) + accordion, swipe-back, swipe-to-close, dock actions.
   Rides on top of theme.Drawers, which owns opening/closing #NavDrawer.
   ========================================================================== */
(function () {
  'use strict';

  var DRAG_MIN = 8;      // px before a gesture is claimed
  var BACK_RATIO = 0.32; // fraction of width to commit a back-swipe
  var VELOCITY = 0.45;   // px/ms flick shortcut

  function init() {
    var mm = document.querySelector('#NavDrawer.mm');
    if (!mm || mm.dataset.mmReady === 'true') return;
    mm.dataset.mmReady = 'true';

    var mode  = mm.getAttribute('data-mm-submenu') || 'accordion';
    var stage = mm.querySelector('.mm__stage');
    var root  = mm.querySelector('.mm__panel--root');
    var stack = [];

    var reduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ------------------------------------------------------------------ */
    /* Accordion                                                           */
    /* ------------------------------------------------------------------ */
    function accordionToggle(btn) {
      var item = btn.closest('.mm__item');
      if (!item) return;
      var willOpen = !item.classList.contains('is-open');

      // single-open per level keeps the drawer tidy
      var siblings = item.parentElement.children;
      for (var i = 0; i < siblings.length; i++) {
        if (siblings[i] === item) continue;
        siblings[i].classList.remove('is-open');
        var t = siblings[i].querySelector(':scope > .mm__row > .mm__toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      }

      item.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', String(willOpen));
    }

    /* ------------------------------------------------------------------ */
    /* Push panels                                                         */
    /* ------------------------------------------------------------------ */
    function currentPanel() {
      return stack.length ? mm.querySelector('#' + CSS_escape(stack[stack.length - 1])) : root;
    }

    // Small helper — ids here are theme-generated (mm-panel-1-2) but be safe.
    function CSS_escape(id) {
      return (window.CSS && CSS.escape) ? CSS.escape(id) : id;
    }

    function openPanel(id) {
      var panel = mm.querySelector('#' + CSS_escape(id));
      if (!panel || panel.classList.contains('is-open')) return;

      var parent = currentPanel();
      if (parent) parent.classList.add('is-parked');

      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      var sc = panel.querySelector('.mm__scroll');
      if (sc) sc.scrollTop = 0;

      stack.push(id);

      var back = panel.querySelector('.mm__back');
      if (back) setTimeout(function () { back.focus({ preventScroll: true }); }, reduced ? 0 : 320);
    }

    function closePanel() {
      var id = stack.pop();
      if (!id) return;

      var panel = mm.querySelector('#' + CSS_escape(id));
      if (panel) {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      }
      var parent = currentPanel();
      if (parent) parent.classList.remove('is-parked');
    }

    function resetPanels() {
      stack = [];
      mm.querySelectorAll('.mm__panel--sub').forEach(function (p) {
        p.classList.remove('is-open', 'is-parked', 'is-dragging');
        p.style.transform = '';
        p.setAttribute('aria-hidden', 'true');
      });
      if (root) {
        root.classList.remove('is-parked', 'is-dragging');
        root.style.transform = '';
        root.style.opacity = '';
      }
      mm.querySelectorAll('.mm__item.is-open').forEach(function (i) {
        i.classList.remove('is-open');
        var t = i.querySelector(':scope > .mm__row > .mm__toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      mm.querySelectorAll('.mm__scroll').forEach(function (s) { s.scrollTop = 0; });
    }

    /* ------------------------------------------------------------------ */
    /* Click delegation                                                    */
    /* ------------------------------------------------------------------ */
    mm.addEventListener('click', function (e) {
      // Image tile that drills into a deeper panel
      var tile = e.target.closest('.mm__tile[data-panel]');
      if (tile) {
        e.preventDefault();
        openPanel(tile.getAttribute('data-panel'));
        return;
      }

      var toggle = e.target.closest('.mm__toggle');
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        var panelId = toggle.getAttribute('data-panel');
        if (mode === 'push' && panelId) openPanel(panelId);
        else accordionToggle(toggle);
        return;
      }

      var back = e.target.closest('.mm__back');
      if (back) {
        e.preventDefault();
        closePanel();
        return;
      }

      var dockSearch = e.target.closest('[data-mm-focus-search]');
      if (dockSearch) {
        e.preventDefault();
        while (stack.length) closePanel();
        var input = mm.querySelector('[data-mm-search]');
        if (input) {
          setTimeout(function () { input.focus(); }, reduced ? 0 : 340);
        } else {
          window.location.href = '/search';
        }
      }
    });

    /* ------------------------------------------------------------------ */
    /* Keyboard                                                            */
    /* ------------------------------------------------------------------ */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;
      if (!document.body.classList.contains('js-drawer-open-left')) return;
      // Esc unwinds one panel at a time before the theme closes the drawer.
      if (stack.length) {
        e.stopPropagation();
        closePanel();
      }
    }, true);

    /* ------------------------------------------------------------------ */
    /* Reset when the drawer closes                                        */
    /* ------------------------------------------------------------------ */
    var wasOpen = false;
    var observer = new MutationObserver(function () {
      var isOpen = document.body.classList.contains('js-drawer-open-left');
      if (wasOpen && !isOpen) setTimeout(resetPanels, 420);
      wasOpen = isOpen;
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    function closeDrawer() {
      var btn = mm.querySelector('.js-drawer-close');
      if (btn) btn.click();
      else document.body.classList.remove('js-drawer-open', 'js-drawer-open-left');
    }

    /* ------------------------------------------------------------------ */
    /* Gestures: swipe-back on a sub-panel, swipe-left to close the drawer */
    /* ------------------------------------------------------------------ */
    if (!reduced && stage) {
      var startX = 0, startY = 0, startT = 0;
      var dx = 0;
      var axis = null;          // null | 'x' | 'y'
      var target = null;        // panel being dragged
      var parked = null;        // its parent
      var closing = false;      // dragging the whole drawer shut
      var ignore = false;       // gesture belongs to something else
      var width = 1;

      /* A horizontal swipe that starts inside a horizontally-scrollable element
         (the collection rail, a carousel, an overflowing row) belongs to THAT
         element, not to the drawer. Without this, swiping the rail left was
         being read as "dismiss the menu". */
      function ownsHorizontalScroll(node) {
        while (node && node !== stage && node.nodeType === 1) {
          if (node.scrollWidth - node.clientWidth > 2) {
            var ox = window.getComputedStyle(node).overflowX;
            if (ox === 'auto' || ox === 'scroll') return true;
          }
          node = node.parentElement;
        }
        return false;
      }

      /* Native form controls and the search field handle their own touches. */
      function isInteractive(node) {
        return !!(node && node.closest && node.closest('input, textarea, select, [contenteditable="true"]'));
      }

      function onStart(e) {
        if (e.touches.length !== 1) return;
        var t = e.touches[0];

        ignore = ownsHorizontalScroll(e.target) || isInteractive(e.target);
        if (ignore) { axis = null; target = null; closing = false; return; }

        startX = t.clientX;
        startY = t.clientY;
        startT = Date.now();
        dx = 0;
        axis = null;
        closing = false;
        width = mm.offsetWidth || window.innerWidth;

        if (stack.length) {
          target = currentPanel();
          parked = null;
          var below = stack.length > 1
            ? mm.querySelector('#' + CSS_escape(stack[stack.length - 2]))
            : root;
          parked = below;
        } else {
          target = null;
          parked = null;
        }
      }

      function onMove(e) {
        if (ignore) return;
        if (e.touches.length !== 1) return;
        var t = e.touches[0];
        var mx = t.clientX - startX;
        var my = t.clientY - startY;

        if (axis === null) {
          if (Math.abs(mx) < DRAG_MIN && Math.abs(my) < DRAG_MIN) return;
          axis = Math.abs(mx) > Math.abs(my) * 1.4 ? 'x' : 'y';
          if (axis === 'x') {
            if (target) {
              target.classList.add('is-dragging');
              if (parked) parked.classList.add('is-dragging');
            } else if (mx < 0) {
              closing = true;
            }
          }
        }
        if (axis !== 'x') return;

        // Sub-panel: drag right to go back
        if (target) {
          dx = Math.max(0, mx);
          var p = dx / width;
          target.style.transform = 'translate3d(' + dx + 'px,0,0)';
          if (parked) {
            var shift = -26 + (26 * p);   // -26% -> 0%
            parked.style.transform = 'translate3d(' + shift + '%,0,0)';
            parked.style.opacity = String(0.34 + 0.66 * p);
          }
          if (e.cancelable) e.preventDefault();
          return;
        }

        // Root: drag left to dismiss the drawer
        if (closing) {
          dx = Math.min(0, mx);
          mm.style.setProperty('transition', 'none', 'important');
          var base = getOpenOffset();
          mm.style.setProperty('transform', 'translateX(calc(' + base + ' + ' + dx + 'px))', 'important');
          var op = Math.max(0, 1 + dx / width);
          mm.style.setProperty('opacity', String(0.35 + 0.65 * op), 'important');
          if (e.cancelable) e.preventDefault();
        }
      }

      function getOpenOffset() {
        if (mm.classList.contains('mm--sheet')) return '100%';
        if (mm.classList.contains('mm--compact')) return '300px';
        return (mm.offsetWidth || 360) + 'px';
      }

      function onEnd() {
        if (ignore) { ignore = false; axis = null; target = null; parked = null; closing = false; dx = 0; return; }
        var dt = Math.max(1, Date.now() - startT);
        var v = Math.abs(dx) / dt;

        if (axis === 'x' && target) {
          target.classList.remove('is-dragging');
          if (parked) parked.classList.remove('is-dragging');
          target.style.transform = '';
          if (parked) { parked.style.transform = ''; parked.style.opacity = ''; }

          if (dx > width * BACK_RATIO || (dx > 40 && v > VELOCITY)) closePanel();

        } else if (axis === 'x' && closing) {
          mm.style.removeProperty('transition');
          mm.style.removeProperty('transform');
          mm.style.removeProperty('opacity');

          if (-dx > width * BACK_RATIO || (-dx > 40 && v > VELOCITY)) closeDrawer();
        }

        axis = null;
        target = null;
        parked = null;
        closing = false;
        ignore = false;
        dx = 0;
      }

      stage.addEventListener('touchstart', onStart, { passive: true });
      stage.addEventListener('touchmove',  onMove,  { passive: false });
      stage.addEventListener('touchend',   onEnd,   { passive: true });
      stage.addEventListener('touchcancel', onEnd,  { passive: true });
    }

    /* ------------------------------------------------------------------ */
    /* Rail: nudge on open so users know it scrolls                        */
    /* ------------------------------------------------------------------ */
    var rail = mm.querySelector('.mm__rail');
    if (rail && !reduced) {
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.js-drawer-open-left')) return;
        setTimeout(function () {
          if (rail.scrollWidth <= rail.clientWidth + 8) return;
          rail.scrollTo({ left: 26, behavior: 'smooth' });
          setTimeout(function () { rail.scrollTo({ left: 0, behavior: 'smooth' }); }, 420);
        }, 700);
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
